import React, { useEffect } from "react";
import { Form, Input, Button, message } from "antd";
import { useMutation, gql } from "@apollo/client";

const CREATE_FACILITY = gql`
  mutation CreateFacility($input: FacilityInput!) {
    createFacility(input: $input) {
      success
      message
      facility {
        id
        facilityName
      }
    }
  }
`;

const UPDATE_FACILITY = gql`
  mutation UpdateFacility($id: ID!, $input: FacilityInput!) {
    updateFacility(id: $id, input: $input) {
      success
      message
      facility {
        id
        facilityName
      }
    }
  }
`;

interface HandleFacilityProps {
  onClose: () => void;
  editFacilityData?: any;
  refreshData?: () => void;
}

const HandleFacility: React.FC<HandleFacilityProps> = ({
  onClose,
  editFacilityData,
  refreshData,
}) => {
  const [form] = Form.useForm();

  const [createFacility] = useMutation(CREATE_FACILITY);
  const [updateFacility] = useMutation(UPDATE_FACILITY);

  useEffect(() => {
    if (editFacilityData) {
      form.setFieldsValue(editFacilityData);
    } else {
      form.resetFields();
    }
  }, [editFacilityData, form]);

  const onFinish = async (values: any) => {
    try {
      if (editFacilityData) {
        const { data } = await updateFacility({
          variables: {
            id: editFacilityData.id,
            input: values,
          },
        });

        if (data?.updateFacility?.success) {
          message.success("Facility updated successfully");
          refreshData?.();
          onClose();
        } else {
          message.error(data?.updateFacility?.message || "Update failed");
        }
      } else {
        const { data } = await createFacility({
          variables: {
            input: values,
          },
        });

        if (data?.createFacility?.success) {
          message.success("Facility created successfully");
          refreshData?.();
          onClose();
        } else {
          message.error(data?.createFacility?.message || "Create failed");
        }
      }
    } catch (err: any) {
      message.error(err.message || "Something went wrong");
    }
  };

  return (
    <div>
      <h2>{editFacilityData ? "Edit Facility" : "Add Facility"}</h2>

      <button onClick={onClose}>Back to Facilities</button>

      <Form
        form={form}
        onFinish={onFinish}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          label="Facility Name"
          name="facilityName"
          rules={[{ required: true, message: "Facility name is required" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item label="Facility Code" name="facilityCode">
          <Input />
        </Form.Item>

        <Form.Item label="Contact" name="facilityContact">
          <Input />
        </Form.Item>

        <Form.Item label="Direct Email" name="facilityDirectAddress">
          <Input />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit">
            {editFacilityData ? "Update Facility" : "Create Facility"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default HandleFacility;